export const TotalTitles = {
    REHAB_SUPPORT: 'Rehab Support',
    TRAVEL_TIME: 'Travel Time',
    TRAVEL_MILEAGE: 'Travel Mileage',
    ACTIVITY_MILEAGE: 'Activity Mileage',
    ACTIVITY_EXPENSES: 'Activity Expenses',
    DOCUMENTATION: 'Documentation',
    COMUNICATION: 'Communication'
};
